import { RdsBreadcrumbItem } from '@rds/angular-components';

const STANDALONE_NEWSLETTER_PREFIX = 'standalone-newsletter';
const NEWSLETTER_PREFIX = 'newsletter';
const WORKSPACE_BREADCRUMB_TEXT = 'RocheHome Workspace';

function normalizePath(path: string): string {
	return path.startsWith('/') ? path.slice(1) : path;
}

export function isStandaloneNewsletterUrl(url: string): boolean {
	return normalizePath(url || '').startsWith(STANDALONE_NEWSLETTER_PREFIX);
}

export function getVisibleBreadcrumbs(
	breadcrumbs: Array<RdsBreadcrumbItem>,
	url: string
): Array<RdsBreadcrumbItem> {
	if (!isStandaloneNewsletterUrl(url)) {
		return breadcrumbs;
	}

	return breadcrumbs.filter((item) => item.text !== WORKSPACE_BREADCRUMB_TEXT);
}

export function resolveBreadcrumbPath(path: string, currentUrl: string): string {
	const normalizedPath = normalizePath(path || '');

	if (!normalizedPath) {
		return normalizedPath;
	}

	if (!isStandaloneNewsletterUrl(currentUrl)) {
		return normalizedPath;
	}

	if (normalizedPath.startsWith(STANDALONE_NEWSLETTER_PREFIX)) {
		return normalizedPath;
	}

	if (normalizedPath === NEWSLETTER_PREFIX) {
		return STANDALONE_NEWSLETTER_PREFIX;
	}

	if (normalizedPath.startsWith(`${NEWSLETTER_PREFIX}/`)) {
		return `${STANDALONE_NEWSLETTER_PREFIX}/${normalizedPath.slice(NEWSLETTER_PREFIX.length + 1)}`;
	}

	if (normalizedPath === 'workspace') {
		return STANDALONE_NEWSLETTER_PREFIX;
	}


	return `${STANDALONE_NEWSLETTER_PREFIX}/${normalizedPath}`;
}
